<div class="auth-shell">
	<section class="login-card">
		<h2 class="card-title">{{ title() }}</h2>
		<p class="card-subtitle">{{ subtitle() }}</p>

		<form (ngSubmit)="onLogin()" class="login-form">
			@if (showUsernameField()) {
				<label for="auth-username" class="label">Username</label>
				<input
					id="auth-username"
					type="text"
					name="username"
					[(ngModel)]="username"
					autocomplete="username"
					class="input"
				/>
			}

			<label for="auth-password" class="label">Password</label>
			<div class="password-wrap">
				<input
					id="auth-password"
					[name]="'password'"
					[type]="showPassword() ? 'text' : 'password'"
					[(ngModel)]="password"
					autocomplete="current-password"
					class="input password-input"
				/>
				<button
					type="button"
					class="eye-btn"
					(click)="togglePasswordVisibility()"
					[attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
				>
					<i class="bi" [ngClass]="showPassword() ? 'bi-eye-slash' : 'bi-eye'"></i>
				</button>
			</div>

			<div *ngIf="error()" class="error-text">{{ error() }}</div>

			<button type="submit" class="login-btn" [disabled]="isSubmitting()">
				{{ isSubmitting() ? 'Signing in...' : 'Sign In' }}
			</button>
		</form>
	</section>
</div>
